import { InputContext } from "./chunk-GBSFMBQH.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Input/Input.Input.tsx
import { forwardRef, useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "input";
var INPUT_INPUT_CLASSNAME_MAP = {};
var InputInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["as", "isLoading", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    disabled,
    validation
  } = useContext(InputContext);
  return /* @__PURE__ */jsx(Component, __spreadValues({
    ref,
    disabled,
    "aria-invalid": validation === "error",
    "aria-busy": isLoading ? "true" : void 0,
    "aria-live": isLoading ? "polite" : void 0,
    className: clsx("pd:input__input", className)
  }, rest));
});
var Input_Input_default = InputInput;
export { INPUT_INPUT_CLASSNAME_MAP, Input_Input_default };